import CaptainTrainingDocumentAPI from 'dashboard/api/captain/trainingDocument';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'CaptainTrainingDocument',
  API: CaptainTrainingDocumentAPI,
});
